export default "__VITE_ASSET__D6X_TWOx__"